// extracted by mini-css-extract-plugin
module.exports = {"Engineering":"Engineering_Engineering__Z7Poj"};